module.exports = __webpack_public_path__ + "static2023-4-17/img/reader-popup_bg.f42db992.png";